// Common constants used across the application
export const BATCH_YEARS = [
  { label: "2024 - 2026", value: "2024-2026" },
  { label: "2025 - 2026", value: "2025-2026" },
  { label: "2025 - 2027", value: "2025-2027" },
];


export const GENDER_OPTIONS = [
  { value: "Male", label: "Male" },
  { value: "Female", label: "Female" },
  { value: "Others", label: "Others" },
];